import { render, staticRenderFns } from "./ContractorListItem.vue?vue&type=template&id=0a040b30&"
import script from "./ContractorListItem.vue?vue&type=script&lang=ts&"
export * from "./ContractorListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports